import { UtilityService } from './../common/utility.service';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { DataService } from '../service/data.service';

@Injectable()

export class FileuploadService {
  constructor(
    private dataService: DataService,
    private utilityService: UtilityService
  ){}

  private fileupdateInsertarUrl: string = 'image/PostImage'; //'fileupload/insertar';
  private fileupdateEliminarUrl: string = 'image/DeleteImage'; //'fileupload/eliminar';
  private fileupdateObtenerUrl: string = 'image/GetObtenerImage'; //'image/PostObtenerImage';
  private fileupdateGuardarUrl: string = 'fileupload/guardar';

  fileuploadInsertar(file: File, fileName: string, clase: string, tipo: string): any {
    let formData: FormData = new FormData();
    formData.append('uploadFile', file, fileName);
    formData.append('clase', clase);
    formData.append('tipo', tipo);

    let headers = new Headers();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append("Access-Control-Allow-Origin", "*");

    this.dataService._baseUri = environment.serviceImageUrl + this.fileupdateInsertarUrl;
		return this.dataService.execPostJsonHeader(formData, headers);
  }

  fileuploadDelete(filePath: string): any {
    let parameters: string;
    parameters = JSON.stringify({
      filePath: filePath
    });

    this.dataService._baseUri = environment.serviceImageUrl + this.fileupdateEliminarUrl + '?filePath=' + filePath;
    return this.dataService.execPostJson(parameters);
  }

  fileuploadGet(filePath: string): any {
    this.dataService._baseUri = environment.serviceImageUrl + this.fileupdateObtenerUrl + '?filePath=' + filePath;
    return this.dataService.execGetOctet();
  }

}
